import { HttpClient } from '@angular/common/http';
import { Configuration, PricelistPrivateControllerApiService } from '@lx/shared/api';
import { environment } from '../../environments/environment';

export function privatePriceListApiFactory(http: HttpClient): PricelistPrivateControllerApiService {
  const basePath = environment.API_PRIVATE_BASE_PATH;
  const config = new Configuration({ basePath });
  return new PricelistPrivateControllerApiService(http, basePath, config);
}

export const PRIVATE_PRICE_LIST_API_PROVIDER = {
  provide: PricelistPrivateControllerApiService,
  useFactory: privatePriceListApiFactory,
  deps: [HttpClient],
};
